module.exports = __webpack_public_path__ + "img/assegna.505781fb.svg";